import { Object3D } from "three";
import { Command } from "./Command";
import { logger } from "../util/Logger";

export class DeleteCommand implements Command {
  private _object: Object3D;
  private _originalParent: Object3D | null = null;

  constructor(object: Object3D) {
    this._object = object;
    this._originalParent = object.parent || null;
    this.do();
  }

  ref(): object | undefined | void {
    return this._object;
  }

  action(): void {}

  do(): void {
    logger.info("DeleteCommand.do", this._object.parent);
    if (this._originalParent) {
      this._object.removeFromParent();
    }
  }

  undo(): void {
    logger.info("DeleteCommand.undo", this._originalParent);
    if (this._originalParent) {
      this._originalParent.add(this._object);
    }
  }

  release(): void {}
}
